module.exports = __webpack_public_path__ + "base_feirao.png?224530294d093b5788093c554a33d1f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base_feirao.png
// module id = 13
// module chunks = 0